export { default } from './all-courses';
